import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import Pagination from 'components/Common/newPagination';
import ReleaseService from './ReleaseService';
import { CommonUtilities } from 'commonUtils';

export default function ReleaseLinkDetails(param: any) {

    console.log(param)
    let [msgZeroFix, setmsgZeroFix] = useState(false)
    let [selectedTrack, setSelectedTrack] = useState<any>([]);
    let [ReleaseContractTracks, setReleaseContractTracks] = useState<any>([]);
    let [ReleaseContractTrackTemp, setReleaseContractTrackTemp] = useState<any>([]);
    let [ReleaseContractTrackCount, setReleaseContractTrackCount] = useState(0);

    const closeDrawer = () => { param.onChangReleaseLinkDetail(); }
    var pagination = { pageNumber: 1, pageSize: 10, }

    useEffect(() => {

        selectedTrack = param?.selectedValue;
        setSelectedTrack(selectedTrack)
        apiCall();
    }, []);

    const apiCall = () => {
        var payload = { releaseCode: selectedTrack?.catLogNumber, type: "ReleaseContractTracks" }

        ReleaseService.genericListing(payload).then((respond: any) => {
            ReleaseContractTracks = CommonUtilities.relativeDataRemapping(respond.data, respond.headers.original).slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
            ReleaseContractTrackTemp = CommonUtilities.relativeDataRemapping(respond.data, respond.headers.original)
            setReleaseContractTracks(ReleaseContractTracks)
            setReleaseContractTrackTemp(ReleaseContractTrackTemp)

            ReleaseContractTrackCount = respond?.totalRows ?? 0
            setReleaseContractTrackCount(ReleaseContractTrackCount)
        })
    }

    const onPageChange = (e: any) => {

        pagination.pageSize = e.pageSize;
        pagination.pageNumber = e.pageNumber;

        ReleaseContractTracks = ReleaseContractTrackTemp.slice((pagination.pageNumber - 1) * pagination.pageSize, pagination.pageSize * pagination.pageNumber);
        setReleaseContractTracks(ReleaseContractTracks)
    }

    const ZeroAndFix = () => {


        var payLoad = {
            contractRefNum: selectedTrack?.contractRefNum,
            catLogNumber: selectedTrack?.catLogNumber
        }
        ReleaseService.zeroFixContractAsset(payLoad).then((respond: any) => {
            apiCall();
        })
    }

    const AutoUpdate = () => {

        const payload = selectedTrack
        payload.automaticUpd = !payload.automaticUpd

        console.log(payload)

        ReleaseService.mainContractsSave(selectedTrack).then((respond: any) => {

            for (var i = 0; i < respond?.length; i++) {

                if (respond[i]?.splitId == selectedTrack?.splitId) {
                    selectedTrack = respond[i];
                    setSelectedTrack(selectedTrack)
                }
            }
        })
    }

    return (<>
        <Drawer open={param.ReleaseLinkDetailOpen} onClose={closeDrawer} direction='right' className='react-drawer allowHscroll allowVscroll' size={800}>

            <div className="ws-9 pull-right box">
                <div className='ws-12 landing'>


                    <div className="box-header-main"> <h2>Release Details</h2>  </div>

                    <div className="box-content">
                        <div className="ws-12">

                            <fieldset className="scheduler-border p0 m0">
                                <legend className="scheduler-border">
                                    <h2 style={{ color: "#47529d" }}> <i className="fa fa-sticky-note-o"></i> Release Info </h2>
                                </legend>

                                <div className="ws-12">

                                    <div className="ws-8">

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr"> Catalog : </label>
                                                <div className="label-entries ws-6">  {selectedTrack?.catLogNumber}  </div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr">   Total tracks : </label>
                                                <div className="label-entries ws-6"> {selectedTrack?.relTracks}  </div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr"> Artist : </label>
                                                <div className="label-entries ws-6">{selectedTrack?.releaseArtist}</div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr"> Tracks this contract :  </label>
                                                <div className="label-entries ws-6">{selectedTrack?.contractTrackCount}</div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr">   Title :  </label>
                                                <div className="label-entries ws-6">{selectedTrack?.releaseTitle} </div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr"> Calc Split : </label>
                                                <div className="label-entries ws-6"> {selectedTrack?.contractSplit} </div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr">  &nbsp;  </label>
                                                <div className="label-entries ws-6">  &nbsp; </div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr"> Manual Split : </label>
                                                <div className="label-entries ws-6"> {selectedTrack?.manualSplit}  </div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <label className="control-label ws-6 text-right pr">Contract :</label>
                                                <div className="label-entries ws-6"> {selectedTrack?.contractTitle} </div>
                                            </div>
                                        </div>

                                        <div className="ws-6">
                                            <div className="form-format">
                                                <div className="label-entries ws-6">
                                                    {!msgZeroFix && <button className="icon-btn edit ps pull-right" onClick={ZeroAndFix}>Zero And Fix </button>}
                                                    {msgZeroFix && <button ng-show="msgZeroFix" className="icon-btn edit ps">Zero Fix Applied</button>}
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="ws-4 mbl">
                                        <button className="icon-btn delete pull-right" onClick={closeDrawer}>Close </button>
                                        <img alt="Korrect"  className="pLarge pts pbs" height="200px" src={selectedTrack?.releaseImageTH} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />
                                    </div>

                                </div>

                            </fieldset>

                        </div>

                        <div className="ws-12 mtl box">
                            <div className="ws-12 ptl pt pb box-header">
                                <span className="text-bold text-m ws-4">Track Listing ({ReleaseContractTrackCount})</span>

                                <div className="form-format ws-4 pull-right">
                                    <div className="label-entries pull-right ws-3">
                                        <label className="switch mbs pull-right ">
                                            <input type="checkbox" onChange={AutoUpdate} checked={selectedTrack.automaticUpd} />
                                            {selectedTrack.automaticUpd == true && <span className="slider round text-left white pm pts">Yes</span>}
                                            {selectedTrack.automaticUpd !== true && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                        </label>
                                    </div>
                                    <label className="control-label text-right pr pull-right ws-6">   Auto-Update :  </label>
                                </div>
                            </div>

                            <div className="ws-12 mtl pm">
                                {ReleaseContractTrackCount == 0 && <div className="alert mt mb"> No tracks found  </div>}

                                {ReleaseContractTrackCount > 0 && <table className="framelessTable">
                                    <thead>
                                        <tr>
                                            <th>Sequence</th>
                                            <th>Artist</th>
                                            <th>Track</th>
                                            <th>Contract</th>
                                            <th>Share</th>
                                            <th>Main / Sub</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            ReleaseContractTracks?.map((mapVal: any) => {
                                                return (
                                                    <tr>
                                                        <td className="text-right">{mapVal?.sequence}</td>
                                                        <td >{mapVal?.trackArtist} ({mapVal?.trackArtistName})</td>
                                                        <td >{mapVal?.trackTitle} ({mapVal?.intStdRecCode})</td>
                                                        <td >{mapVal?.contractTitle}</td>
                                                        <td className="text-right">{mapVal?.percentageDeducted}</td>
                                                        <td > {mapVal?.isSubForCurrentContract === mapVal?.contractReFNum ? "Main" : "Sub"}</td>
                                                    </tr>
                                                )
                                            })

                                        }
                                    </tbody>
                                </table>}

                            </div>

                            {ReleaseContractTrackCount > 10 && <div className="box-footer mtl p0" ng-show="releaseContractListings.length &gt; 10">

                                <Pagination totalRow={ReleaseContractTrackCount} onPageChange={onPageChange} />
                            </div>}
                        </div>
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete" onClick={closeDrawer}>Close </button>
                    </div>


                </div>
            </div>
        </Drawer>
    </>
    )
}